import { Item } from '../../core';
import { UNREAD_CATEGORY_ID } from '../const/unread-category';
import { FilterOptions } from '../model/filter-options.model';
import { OrderBy } from '../model/order-by.model';
import { Status } from '../model/status.model';
import { ViewCategory } from '../model/view-category.model';

import { filterByDateRange } from './filter-by-date-range.function';
import { filterByKeyword } from './filter-by-keyword.function';
import { filterByStatus } from './filter-by-status.function';
import { sortItems } from './sort-items.function';

export function filterItems(opts: {
    items: Item[];
    categoryId: string;
    filterOpts: FilterOptions;
    categories: ViewCategory[];
    orderBy: OrderBy;
    retainAsUnreadForUnreadCategory?: number[];
}): Item[] {
    let nextFilt = opts.items.filter(
        (e) =>
            opts.categoryId === UNREAD_CATEGORY_ID ||
            e.categoryId === opts.categoryId,
    );
    nextFilt = filterByStatus(
        opts.categoryId === UNREAD_CATEGORY_ID
            ? [Status.UNREAD]
            : opts.filterOpts.statuses,
        nextFilt,
        opts.retainAsUnreadForUnreadCategory != null &&
            opts.categoryId === UNREAD_CATEGORY_ID
            ? opts.retainAsUnreadForUnreadCategory
            : null,
    );
    nextFilt = filterByDateRange(opts.filterOpts.dateRange, nextFilt);
    nextFilt = filterByKeyword(
        opts.filterOpts.keyword,
        opts.categories,
        nextFilt,
    );
    return sortItems(opts.orderBy, nextFilt);
}
